import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { deleteCostSummary, fetchCostSummaryViewerData, getXmlCostSummary } from "./";

const initialState = {
	headerData: {},
	costData: [],
	tableData: [],
	fetchStatus: null,
	fetchStatusText: null,
};

export const costSummarySlice = createSlice({
	name: "costSummary",
	initialState,
	reducers: {
		setHeaderData: (state, { payload }) => {
			state.headerData = payload;
		},
		setCostData: (state, { payload }) => {
			state.costData = payload;
		},
		setTableData: (state, { payload }) => {
			state.tableData = payload;
		},
		setFetchStatus: (state, { payload }) => {
			state.fetchStatus = payload;
		},
		setFetchStatusText: (state, { payload }) => {
			state.fetchStatusText = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchCostSummaryViewerData.fulfilled, (state, { payload }) => {
			state.headerData = payload.header_data;
			state.costData = payload.cost_data;
			state.tableData = payload.table_data;
			state.fetchStatus = "success";
		});

		builder.addMatcher(isAnyOf(deleteCostSummary.fulfilled, getXmlCostSummary.fulfilled), (state, action) => {
			state.fetchStatus = "success";
		});
		builder.addMatcher(isAnyOf(fetchCostSummaryViewerData.pending, deleteCostSummary.pending, getXmlCostSummary.pending), (state, action) => {
			state.fetchStatus = "loading";
		});
		builder.addMatcher(isAnyOf(fetchCostSummaryViewerData.rejected, deleteCostSummary.rejected, getXmlCostSummary.rejected), (state, action) => {
			state.fetchStatus = "failed";
			if (action?.payload?.response?.data?.error_text) {
				state.fetchStatusText = action?.payload?.response?.data?.error_text;
			}
		});
	},
});

export const { actions: costSummaryActions, reducer: costSummaryReducer } = costSummarySlice;
